import React, { Component } from 'react';
import Modal from '../Modal';
import PortalContacts from '../dashboard/ContactPersons';
import { injectIntl } from 'react-intl';

export class TriggerableModal extends Component {

    constructor(props) {
        super(props);
        this.state = {
            showModal: false
        };
    }

    openModal(e) {
        e.preventDefault();
        this.setState({ showModal: true });
    }

    closeModal() {
        this.setState({ showModal: false });
    }

    render() {
        return (
            <div>
                <Modal
                    close={this.closeModal.bind(this)}
                    isOpen={this.state.showModal}
                    title={this.props.title}
                >
                    {this.props.body}
                    <PortalContacts
                        departmentFilter={this.props.departmentFilter}
                        itemClasses={["col-md-6", "col-lg-6"]}
                        hideTitle
                    />
                </Modal>
                {this.props.children(this.openModal.bind(this))}
            </div>
        );
    }
}

export default injectIntl(TriggerableModal);


// WEBPACK FOOTER //
// ./web/src/components/portal-contact/TriggerableModal.jsx